module.exports = __webpack_public_path__ + "c898bef07bb1c8231fd83f7c2c46c7c7.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/perks/houses/wizards-hut.png
// module id = 606
// module chunks = 0